import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

import ExpansionButton from './ExpansionButton';

const propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
    bg: PropTypes.string,
};

const defaultProps = {
    className: '',
    title: '',
    bg: 'light',
    children: null,
};

class ExpandableWell extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
        };

        this.onToggleExpansion = this.onToggleExpansion.bind(this);
    }

    onToggleExpansion() {
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        return (
            <Card body bg={this.props.bg} className={this.props.className}>
                <ExpansionButton
                    expanded={this.state.expanded}
                    onClick={this.onToggleExpansion}
                >
                    {this.props.leftControl ? null : this.props.title}
                </ExpansionButton>
                {this.props.leftControl ? this.props.title : null}
                {(this.state.expanded) && this.props.children}
            </Card>
        );
    }
}

ExpandableWell.propTypes = propTypes;
ExpandableWell.defaultProps = defaultProps;

export default ExpandableWell;